import React, { FC } from "react"
import { Box, TextField } from "@mui/material"
import { UText } from "@/ui-component"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { updateOnHoldMsg } from "@/core/app/slices/uassist/formSlice"
import { RootState } from "@/core/app/store"

const OnholdMessage: FC = () => {
  const dispatch = useAppDispatch()
  const { onHoldMsg } = useAppSelector((state: RootState) => state.formService)

  return (
    <Box sx={{ my: 3, display: "flex", flexDirection: "column", gap: 1 }}>
      <UText variant="body2">{"Message for uAssistant(optional)"}</UText>
      <TextField
        id="attention-banner-replymsg"
        placeholder="Leave your message here"
        multiline
        minRows={3}
        fullWidth
        value={onHoldMsg || ""}
        onChange={(e) => {
          const value = e.target.value
          dispatch(updateOnHoldMsg(value))
        }}
      />
    </Box>
  )
}

export default OnholdMessage
